import { hasStaticFeedback } from "@memorang/helpers/feedback";
import type { BaseItemSchema } from "@memorang/types";

export const isBlankDragDrop = (item: BaseItemSchema): boolean =>
	item.response.type === "TOKEN_MAPPING" && hasStaticFeedback(item.feedback);

export const isBlankDropdown = (item: BaseItemSchema): boolean =>
	item.metadata?.type === "BLANK_DROPDOWN" && hasStaticFeedback(item.feedback);

export const isMatchingPair = (item: BaseItemSchema): boolean =>
	item.response.type === "PAIR_MATCHING";

export const isMultiSelect = (item: BaseItemSchema): boolean => {
	if (item.type === "MULTI_SELECT") {
		return true;
	}
	const response = item.response;
	if (response.type === "INLINE_TEXT_SELECTION") {
		return true;
	}
	if (response.type === "choice") {
		if ("selectionType" in response && response.selectionType === "multiple") {
			return true;
		}
		if (
			"maxCorrectChoices" in response &&
			(response.maxCorrectChoices ?? 1) > 1
		) {
			return true;
		}
	}
	const scoring = item.scoring;
	return (
		scoring != null &&
		"selection" in scoring &&
		scoring.selection != null &&
		(scoring.selection.max > 1 || scoring.selection.min > 1)
	);
};

const getTotalBlanks = (item: BaseItemSchema): number => {
	if (isBlankDragDrop(item)) {
		const { scoring } = item;
		return scoring && "type" in scoring && scoring.type === "ANSWER_KEY_MAPPING"
			? scoring.answerKey.length
			: 0;
	}
	if (isBlankDropdown(item)) {
		const { response } = item;
		return "blanks" in response ? response.blanks.length : 0;
	}
	if (isMatchingPair(item)) {
		const { response } = item;
		return "left" in response ? response.left.length : 0;
	}
	return 0;
};

export const isAllBlanksFilled = (
	item: BaseItemSchema,
	formState: Record<string, string> | undefined,
): boolean => {
	const totalBlanks = getTotalBlanks(item);
	if (totalBlanks === 0) {
		return false;
	}
	const filledCount = formState
		? Object.values(formState).filter(Boolean).length
		: 0;
	return filledCount >= totalBlanks;
};
